import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Alert } from './alert.model';
@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private alertsSubject = new BehaviorSubject<Alert[]>([]);
  alerts$ = this.alertsSubject.asObservable();

  private counter = 0;

  show(type: Alert['type'], message: string, timeout: number = 5000): void {
    const id = ++this.counter;
    const newAlert: Alert = { id, type, message, closing: false, timeout };

    const current = this.alertsSubject.value;
    this.alertsSubject.next([...current, newAlert]);

    if (timeout > 0) {
      setTimeout(() => this.close(id), timeout);
    }
  }

  close(id: number): void {
    const alerts = this.alertsSubject.value.map(alert =>
      alert.id === id ? { ...alert, closing: true } : alert
    );
    this.alertsSubject.next(alerts);
  }

  remove(id: number): void {
    const alerts = this.alertsSubject.value.filter(a => a.id !== id);
    this.alertsSubject.next(alerts);
  }
}